export const holodeckStateDefaults: IHolodeckState = {
  areGridLinesVisible: true,
  gridLinesColor: '#96C5FA',
  gridLinesOpacity: 0.16,
  lightColor: '#FFFDED',
  lightIntensity: 1.3,
  isEditorDarkMode: true,
  backgroundColor: '#060d22',
  backgroundIntensity: 0.3,
  backdropGrainIntensity: 0.08,
  backdropEnabled: false,
  backdropId: '',
  cameraLock: false,
};
